import { Component, Mixins } from '@/vue-property-decorator'
import { ExhibitFallbackBg } from './exhibitFallbackBg'
import { _FallbackBackgroundBase as FallbackBackgroundBase } from './cssVar/fallbackBackgroundBase'
import { _FallbackBackgroundDefault as FallbackBackgroundDefault } from './cssVar/fallbackBackgroundDefault'
import { _FallbackBackgroundLarger as FallbackBackgroundLarger } from './cssVar/fallbackBackgroundLarger'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import { createSvgSprite } from '@/utils/business-utils/assets'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import style from './style.module.scss'
export {
  FallbackBackgroundBase,
  FallbackBackgroundDefault,
  FallbackBackgroundLarger
}
export type FallbackBackgroundCssVarManager =
  GetCssVarManager<FallbackBackgroundBase>
/** 兜底背景 注意:有使用absolute定位,因此,父级组件必须要有relative才行. */
@Component<FallbackBackground>({
  name: 'FallbackBackground'
})
export default class FallbackBackground extends Mixins<
  BaseCssVarInject<FallbackBackgroundBase>
>(BaseCssVarInject) {
  /** 获得兜底背景图的默认类样式 */
  public static getCssVarDefault = () => new FallbackBackgroundDefault()
  /** 获得兜底背景图的大号类样式(它反而比默认更常用) */
  public static getCssVarLarger = () => new FallbackBackgroundLarger()
  /** 是否显示背景图控制类 */
  public static ExhibitFallbackBg = ExhibitFallbackBg

  render() {
    return (
      <div
        class={{
          ['fallback-background']: true,
          [style['fallback-background']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <icon-sprite sprite={createSvgSprite('img_mryx_card')} />
      </div>
    )
  }
}
